// Validators
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var validateChangePosition = function (graph) { return function (err, command, next) {
    if (command.options.freeTransform) {
        // Position is changed after resize
        return next(err);
    }
    var cell = graph.getCell(command.data.id);
    if (!isPositionValid(graph, cell)) {
        return next({ cell: cell, msg: 'positioning error' });
    }
    return next(err);
}; };
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var validateChangeSize = function (graph) { return function (err, command, next) {
    var cell = graph.getCell(command.data.id);
    if (!isSizeValid(graph, cell)) {
        return next({ cell: cell, msg: 'resizing error' });
    }
    return next(err);
}; };
// Checks
export var isSizeValid = function (graph, element) {
    if (element.get('type') === 'app.Shelf') {
        if (doProductsOverflow(element) || doesShelfOverlap(graph, element)) {
            return false;
        }
    }
    else {
        if (doesProductOverflow(graph, element) || doesProductOverlap(graph, element)) {
            return false;
        }
    }
    return true;
};
export var isPositionValid = function (graph, element) {
    if (element.get('type') === 'app.Shelf') {
        if (doesShelfOverlap(graph, element)) {
            return false;
        }
    }
    else {
        if (doesProductOverlap(graph, element) || doesProductOverflow(graph, element)) {
            return false;
        }
    }
    return true;
};
export var doesProductOverlap = function (graph, product) {
    var models = graph.findModelsUnderElement(product);
    if (models.length === 0)
        return true;
    return models.some(function (el) { return el.isEmbedded(); });
};
export var doesShelfOverlap = function (graph, shelf) {
    return graph.findModelsUnderElement(shelf).length > 0;
};
export var doesProductOverflow = function (graph, product) {
    var shelf = product.getParentCell();
    var productBBox = product.getBBox();
    if (!shelf) {
        var models = graph.findModelsInArea(productBBox).filter(function (el) {
            return el !== product && !el.isEmbedded();
        });
        if (models.length !== 1)
            return true;
        shelf = models[0];
    }
    return !shelf.getBBox().containsRect(productBBox);
};
export var doProductsOverflow = function (shelf) {
    var products = shelf.getEmbeddedCells();
    var shelfBBox = shelf.getBBox();
    return products.some(function (product) {
        return !shelfBBox.containsRect(product.getBBox());
    });
};
